import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

// Modules
import shop from "@/store/modules/shop";
import auth from "@/store/modules/auth";
import resort from "@/store/modules/resort";
import customer from "@/store/modules/customer";
import order from "@/store/modules/order";
import device from "@/store/modules/device";
import prices from "@/store/modules/prices";

Vue.use(Vuex);

const vuexPersist = new VuexPersistence({
  storage: window.sessionStorage
});

export default new Vuex.Store({
  state: {},
  getters: {},
  actions: {},
  mutations: {},
  modules: {
    auth,
    customer,
    device,
    order,
    prices,
    resort,
    shop
  },
  strict: process.env.NODE_ENV !== "development",
  devtools: process.env.NODE_ENV === "development",
  plugins: [vuexPersist.plugin]
});
